module.exports = __webpack_public_path__ + "img/fig09.3c6e8f6c.jpg";